import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/feature/ScrollToTop";
import {
  OrganizationJsonLD,
  WebSiteJsonLD,
  WebPageJsonLD,
  FAQPageJsonLD,
} from "@/components/feature/JsonLD";
import { categories } from "@/mocks/categories";
import { getLatestArticles, getHotArticles } from "@/mocks/articles";
import { faqs } from "@/mocks/faqs";

const hotArticles = getHotArticles(4);
const latestArticles = getLatestArticles(6);

const hotWelfares = [
  {
    id: "hot-1",
    title: "淘宝618优惠券",
    desc: "跨店满300减50，品类券叠加更划算",
    icon: "ri-shopping-bag-3-line",
    color: "accent" as const,
  },
  {
    id: "hot-2",
    title: "Netflix会员共享",
    desc: "4人拼车每人仅需¥22/月，4K画质",
    icon: "ri-netflix-line",
    color: "primary" as const,
  },
  {
    id: "hot-3",
    title: "Apple教育优惠",
    desc: "MacBook最高省¥1,600，还送AirPods",
    icon: "ri-apple-line",
    color: "secondary" as const,
  },
  {
    id: "hot-4",
    title: "交通补贴申领",
    desc: "北上广深各城市最高¥500/月",
    icon: "ri-bus-line",
    color: "accent" as const,
  },
  {
    id: "hot-5",
    title: "移动积分兑换",
    desc: "1000积分=¥10话费，年底前记得清",
    icon: "ri-exchange-dollar-line",
    color: "primary" as const,
  },
  {
    id: "hot-6",
    title: "B站大会员",
    desc: "学生认证年费仅¥98，联合会员更值",
    icon: "ri-bilibili-line",
    color: "secondary" as const,
  },
];

const colorMap = {
  primary: {
    bg: "bg-primary-100",
    text: "text-primary-700",
    iconBg: "bg-primary-500",
  },
  accent: {
    bg: "bg-accent-100",
    text: "text-accent-700",
    iconBg: "bg-accent-500",
  },
  secondary: {
    bg: "bg-secondary-100",
    text: "text-secondary-700",
    iconBg: "bg-secondary-500",
  },
};

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <OrganizationJsonLD />
      <WebSiteJsonLD />
      <WebPageJsonLD
        title="福利导航 - 一站式福利资源聚合平台"
        description="福利导航为您精准汇聚海量福利资源，涵盖购物优惠、会员权益、生活补贴、职场福利等多维度内容。帮您快速找到最划算的福利入口，省时省力不错过任何好处。"
        url="https://fulidaohang.com"
      />
      <FAQPageJsonLD questions={faqs} />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        {/* Hero Section */}
        <section className="relative w-full h-[480px] md:h-[600px] flex items-center justify-center overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=warm%20modern%20abstract%20background%20with%20soft%20flowing%20gradient%20shapes%20in%20warm%20orange%20and%20cream%20tones%2C%20minimalist%20geometric%20pattern%2C%20clean%20and%20elegant%20atmosphere%2C%20soft%20light%20blur%20effect%2C%20corporate%20friendly%20style&width=1600&height=900&seq=hero-welfare-bg&orientation=landscape"
              alt="福利导航背景"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45"></div>
          <div className="relative z-10 w-full px-4 md:px-6 text-center max-w-3xl mx-auto">
            <h1 className="font-heading text-2xl md:text-4xl font-bold text-white mb-4 leading-tight">
              一站式福利资源聚合平台
            </h1>
            <p className="text-base md:text-lg text-white/80 mb-8 max-w-xl mx-auto leading-relaxed">
              精准汇聚购物优惠、会员权益、生活补贴、职场福利等多维度福利信息，帮您快速找到最划算的福利入口
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/category/gouwu-youhui"
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 rounded-lg font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                开始探索福利
              </Link>
              <Link
                to="/about"
                className="w-full sm:w-auto px-8 py-3.5 bg-background-50/20 text-white border border-white/30 rounded-lg font-medium text-sm hover:bg-background-50/30 transition-colors whitespace-nowrap"
              >
                了解更多
              </Link>
            </div>
          </div>
        </section>

        {/* Hot Welfare Cards */}
        <section className="w-full px-4 md:px-6 py-14 md:py-18">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="font-heading text-xl md:text-3xl font-semibold text-foreground-900 mb-3">
                热门福利速递
              </h2>
              <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
                实时更新最受关注的福利资源，一键直达领取入口
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {hotWelfares.map((item) => {
                const c = colorMap[item.color];
                return (
                  <div
                    key={item.id}
                    className="group bg-background-50 border border-background-200/70 rounded-lg p-5 flex items-start gap-4 hover:border-primary-200 transition-all cursor-pointer"
                  >
                    <div
                      className={`w-12 h-12 rounded-lg ${c.iconBg} flex items-center justify-center flex-shrink-0`}
                    >
                      <i className={`${item.icon} text-lg text-background-50`}></i>
                    </div>
                    <div className="flex-1 min-w-0">
                      <h3 className="font-heading text-base font-semibold text-foreground-900 mb-1 group-hover:text-primary-500 transition-colors">
                        {item.title}
                      </h3>
                      <p className="text-sm text-foreground-600 leading-relaxed">
                        {item.desc}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* Category Navigation Grid */}
        <section className="w-full px-4 md:px-6 py-14 md:py-18 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="font-heading text-xl md:text-3xl font-semibold text-foreground-900 mb-3">
                福利分类导航
              </h2>
              <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
                按类别精准查找，快速定位你需要的福利资源
              </p>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
              {categories.map((cat) => {
                const c = colorMap[cat.color as keyof typeof colorMap];
                return (
                  <Link
                    key={cat.id}
                    to={`/category/${cat.slug}`}
                    className="group bg-background-50 rounded-lg p-5 text-center border border-background-200/70 hover:border-primary-200 transition-all"
                  >
                    <div
                      className={`w-14 h-14 mx-auto rounded-xl ${c.bg} flex items-center justify-center mb-3 group-hover:scale-110 transition-transform`}
                    >
                      <i className={`${cat.icon} text-xl ${c.text}`}></i>
                    </div>
                    <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1 whitespace-nowrap">
                      {cat.name}
                    </h3>
                    <p className="text-xs text-foreground-500">
                      {cat.articleCount} 篇福利
                    </p>
                  </Link>
                );
              })}
            </div>
          </div>
        </section>

        {/* Latest Articles */}
        <section className="w-full px-4 md:px-6 py-14 md:py-18">
          <div className="max-w-7xl mx-auto">
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-10 gap-3">
              <div>
                <h2 className="font-heading text-xl md:text-3xl font-semibold text-foreground-900 mb-2">
                  最新福利文章
                </h2>
                <p className="text-foreground-600 text-sm">
                  持续更新，不错过任何福利信息
                </p>
              </div>
              <Link
                to="/category/gouwu-youhui"
                className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 whitespace-nowrap"
              >
                查看全部
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {latestArticles.map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.slug}`}
                  className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-200 transition-all"
                >
                  <div className="relative w-full h-48 overflow-hidden">
                    <img
                      src={article.imageUrl}
                      alt={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-4 md:p-5">
                    <div className="flex items-center gap-3 mb-3">
                      <span className="text-xs text-foreground-500 flex items-center gap-1">
                        <i className="ri-calendar-line"></i>
                        {article.publishedAt}
                      </span>
                      <span className="text-xs text-foreground-500 flex items-center gap-1">
                        <i className="ri-time-line"></i>
                        {article.readTime}
                      </span>
                    </div>
                    <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                      {article.title}
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                      {article.excerpt}
                    </p>
                    <div className="flex flex-wrap gap-2 mt-4">
                      {article.tags.slice(0, 3).map((tag) => (
                        <span
                          key={tag}
                          className="text-xs px-2.5 py-1 rounded-md bg-secondary-100 text-secondary-700 whitespace-nowrap"
                        >
                          {tag}
                        </span>
                      ))}
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="w-full px-4 md:px-6 py-14 md:py-18 bg-background-100">
          <div className="max-w-3xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="font-heading text-xl md:text-3xl font-semibold text-foreground-900 mb-3">
                常见问题
              </h2>
              <p className="text-foreground-600 text-sm md:text-base">
                关于福利导航的常见疑问，我们在此为您解答
              </p>
            </div>
            <div className="flex flex-col gap-3">
              {faqs.map((faq) => (
                <details
                  key={faq.id}
                  className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden"
                >
                  <summary className="flex items-center justify-between p-5 cursor-pointer hover:bg-background-100 transition-colors">
                    <h3 className="font-heading text-sm md:text-base font-medium text-foreground-900 pr-8">
                      {faq.question}
                    </h3>
                    <span className="flex-shrink-0 w-5 h-5 flex items-center justify-center text-foreground-500 group-open:rotate-180 transition-transform">
                      <i className="ri-arrow-down-s-line"></i>
                    </span>
                  </summary>
                  <div className="px-5 pb-5">
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        {/* Newsletter CTA */}
        <section className="w-full px-4 md:px-6 py-14 md:py-18">
          <div className="max-w-2xl mx-auto text-center">
            <div className="w-16 h-16 mx-auto mb-5 rounded-full bg-primary-100 flex items-center justify-center">
              <i className="ri-mail-send-line text-2xl text-primary-500"></i>
            </div>
            <h2 className="font-heading text-xl md:text-3xl font-semibold text-foreground-900 mb-3">
              订阅最新福利资讯
            </h2>
            <p className="text-foreground-600 text-sm md:text-base mb-8">
              第一时间获取最新福利信息，不错过任何优惠机会
            </p>
            <form
              data-readdy-form
              action="https://readdy.ai/api/form/d9qmp4snlsngrm4lm29g"
              method="POST"
              className="flex flex-col sm:flex-row items-center justify-center gap-3"
            >
              <input
                type="email"
                name="email"
                placeholder="请输入您的邮箱地址"
                required
                className="w-full sm:w-80 px-5 py-3.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
              />
              <button
                type="submit"
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 rounded-lg font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                立即订阅
              </button>
              <input
                type="text"
                name="phone_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="contact-hp"
              />
            </form>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}